export default "__VITE_ASSET__CnX2lIuG__"